<template>
  <b-modal
        scrollable
    id="is-article-pending-modal"
    ref="modal"
    header-class="headerModal"
    centered
    size="s"
    :title="`${$t('MoveToTransit')}`"
    hide-footer
    @hide="onCancel"
  >
    <LoadingWrapperSpinner
      request-id="loadIsProductInTransit"
      :response-data="getIsProductInTransit"
      style="border:transparent !important;"
    >
      <div
        v-if="!getIsProductInTransit"
        class="display-articles"
      >
        <b-form-group
          :label="$t('Article')"
        >
          <b-form-input
            v-model="clickedArticle"
            disabled
          />
        </b-form-group>
        <b-form-group
          :label="$t('Location')"
        >
          <b-form-input
            v-model="clickedLocation"
            disabled
          />
        </b-form-group>
        <b-form-group
          :label="$t('MaxQuantity')"
        >
          <b-form-input
            v-model="amountOfProduct"
            disabled
          />
        </b-form-group>
        <b-form-group
          :label="$t('Quantity')"
        >
          <b-form-input
            v-model.number="newQuantity"
            min="0"
            :max="amountOfProduct"
          />
          <p
            v-if="(newQuantity <= 0 || newQuantity > amountOfProduct) && buttonSubmited"
            style="color: red;"
          >
            {{ $t('MaxQuantity') }}: {{ amountOfProduct }} {{ $t('And') }} {{ $t('Quantity') }} > 0
          </p>
        </b-form-group>
      </div>
    </LoadingWrapperSpinner>
    <span
      v-if="getIsProductInTransit"
      style="color: #262E6C; font-weight: bold;"
    >
      {{ $t('AlreadyInTransit') }}
    </span>
    <div class="buttonsEverywhere">
      <button
        type="button"
        variant="none"
        style="margin-left: 0px;"
        class="buttonSubmit"
        :disabled="getIsProductInTransit"
        @click="onSubmit"
      >
      <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <b-button
        type="reset"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'


export default {
  props: ['clickedArticle', 'clickedLocation', 'amountOfProduct', 'clickedProductId'],
  data() {
    return {
      newQuantity: 0,
      loading: false,
      buttonSubmited: false,
    }
  },
  computed: {
    ...mapGetters([
      'getIsProductInTransit',
    ]),
  },
  methods: {
    ...mapActions([
      'loadAddProductsInStockPending',
      'resetIsProductInTransit',
      'resetTotalStockGroupedByLocationSidebar',
    ]),
    async onSubmit() {
      this.buttonSubmited = true
      if ((this.newQuantity <= 0 || this.newQuantity > this.amountOfProduct)) {
        return
      }
      const objekti = {
        productInStockId: this.clickedProductId,
        amount: this.newQuantity,
        notes: this.notes,
      }
      try {
        this.loading = true
        await this.loadAddProductsInStockPending({
          object: objekti,
          successCallback: () => {
            this.loading = false
            this.$refs.modal.hide();
            this.onReset();
            this.resetTotalStockGroupedByLocationSidebar()
            this.$emit('updateProductsInStockPending');
          },
        });
      } catch (error) {
        this.loading = false
      }
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.newQuantity = 0
      this.loading = false
      this.buttonSubmited = false
      this.resetIsProductInTransit()
      this.$refs.modal.hide();
    },
  },
}
</script>

<style lang="scss" scoped>
.display-articles{
display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
}

</style>
